import { ActionType } from "./types";

/** List of apps that are filtered out from Agents completely */
export const FILTERED_APPS: Record<string, boolean> = {
  FilterAPI: true, // Filter by Zapier
  BranchingAPI: true, // Paths by Zapier
  DelayAPI: true, // Delay by Zapier
  SubZapCLIAPI: true, // Sub-Zap by Zapier
  DelayCLIAPI: true, // Delay by Zapier
  ZapierLoopingCLIAPI: true, // Looping by Zapier
  App222036CLIAPI: true, // Agents by Zapier
  App212686CLIAPI: true, // Human in the Loop (staging)
  App226439CLIAPI: true, // Human in the Loop (prod)
};

/**
 * Map of app ➡️ action ➡️ action type
 *
 * List of actions that are filtered out from Agents completely.
 */
export const FILTERED_ACTIONS: Record<
  string,
  Record<string, Partial<Record<ActionType, true>>>
> = {
  SlackCLIAPI: {
    pushed_message: {
      /**
       * Pushed message action is filtered out since it can't push to Central (...yet!)
       */
      read: true,
    },
    request_approval: {
      /**
       * HitL not supported yet by Agents
       */
      write: true,
    },
  },
};

/**
 * This list is taken from here: https://gitlab.com/zapier/configs/-/blob/master/django_settings/production/default.py#L2540-2623
 */
export const PY2CLI_SELECTED_API_MAPPING: Record<string, string> = {
  AWeberCLIAPI: "AWeberAPI",
  Basecamp3CLIAPI: "Basecamp3API",
  BasecampNextV2CLIAPI: "BasecampNextV2API",
  BraintreeCLIAPI: "BraintreeAPI",
  BoxCLIAPI: "BoxAPI",
  CampaignMonitorCLIAPI: "CampaignMonitorAPI",
  ChargifyCLIAPI: "ChargifyAPI",
  CodeCLIAPI: "CodeAPI",
  DelayCLIAPI: "DelayAPI",
  DigestCLIAPI: "DigestAPI",
  EmailV2CLIAPI: "EmailV2API",
  EvernoteBusinessCLIAPI: "EvernoteBusinessAPI",
  EvernoteCLIAPI: "EvernoteAPI",
  ExcelCLIAPI: "ExcelAPI",
  FacebookCustomAudienceCLIAPI: "FacebookCustomAudienceAPI",
  FacebookLeadsCLIAPI: "FacebookLeadsAPI",
  FacebookMessengerCLIAPI: "FacebookMessengerAPI",
  FacebookV2CLIAPI: "FacebookV2API",
  FilterCLIAPI: "FilterAPI",
  FlowdockCLIAPI: "FlowdockAPI",
  FreshBooksCLIAPI: "FreshBooksAPI",
  GitHubCLIAPI: "GitHubAPI",
  GoToWebinarCLIAPI: "GoToWebinarAPI",
  GoogleAnalytics4CLIAPI: "GoogleAnalyticsAPI",
  GoogleAssistantCLIAPI: "GoogleAssistantAPI",
  GoogleCalendarCLIAPI: "GoogleCalendarAPI",
  GoogleContactsCLIAPI: "GoogleContactsV2API",
  GoogleDocsV2CLIAPI: "GoogleDocsV2API",
  GoogleDriveCLIAPI: "GoogleDriveAPI",
  GoogleFormsV2CLIAPI: "GoogleFormsV2API",
  GoogleMailCLIAPI: "GoogleMailAPI",
  GoogleMailV2CLIAPI: "GoogleMailV2API",
  GoogleSheetsV2CLIAPI: "GoogleSheetsV2API",
  HarvestCLIAPI: "HarvestAPI",
  HighriseCLIAPI: "HighriseAPI",
  IMAPCLIAPI: "IMAPAPI",
  KeapLegacyCLIAPI: "InfusionSoftAPI",
  InstagramCustomAudienceCLIAPI: "InstagramCustomAudienceAPI",
  InstagramLeadsCLIAPI: "InstagramLeadsAPI",
  LighthouseCLIAPI: "LighthouseAPI",
  MSSQLCLIAPI: "MSSQLAPI",
  MagentoCLIAPI: "MagentoAPI",
  MagentoV2CLIAPI: "MagentoV2API",
  MailboxCLIAPI: "MailboxAPI",
  MySQLCLIAPI: "MySQLAPI",
  OdooERPCLIAPI: "OdooAPI",
  PayPalCLIAPI: "PayPalAPI",
  PocketCLIAPI: "PocketAPI",
  PodioCLIAPI: "PodioAPI",
  PostgreSQLCLIAPI: "PostgreSQLAPI",
  QuickBooksV3CLIAPI: "QuickBooksV3API",
  RSSCLIAPI: "RSSAPI",
  RedmineCLIAPI: "RedmineAPI",
  S3CLIAPI: "S3API",
  SESCLIAPI: "SESAPI",
  SMSCLIAPI: "SMSAPI",
  SMTPCLIAPI: "SMTPAPI",
  SNSCLIAPI: "SNSAPI",
  SQSCLIAPI: "SQSAPI",
  SalesforceCLIAPI: "SalesforceAPI",
  ScheduleCLIAPI: "ScheduleAPI",
  ShopifyCLIAPI: "ShopifyAPI",
  SlackCLIAPI: "SlackAPI",
  Solve360CLIAPI: "Solve360API",
  StripeLegacyCLIAPI: "StripeAPI",
  TeamboxCLIAPI: "TeamboxAPI",
  TeamworkPMCLIAPI: "TeamworkPMAPI",
  TrelloCLIAPI: "TrelloAPI",
  TwilioCLIAPI: "TwilioAPI",
  WebHookCLIAPI: "WebHookAPI",
  WordpressCLIAPI: "WordpressAPI",
  WordpressV2CLIAPI: "WordpressV2API",
  WufooCLIAPI: "WufooAPI",
  XeroCLIAPI: "XeroAPI",
  YammerCLIAPI: "YammerAPI",
  YouTubeV3CLIAPI: "YouTubeV3API",
  YouTubeV4CLIAPI: "YouTubeV4API",
  ZapierCLIAPI: "ZapierAPI",
  ZapierInternalCLIAPI: "ZapierInternalAPI",
  ZapierMailCLIAPI: "ZapierMailAPI",
  ZapierManagerCLIAPI: "ZapierManagerAPI",
  ZendeskV2CLIAPI: "ZendeskV2API",
  ZillowCLIAPI: "ZillowAPI",
};
